import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import styles from './Block.css'

const propTypes = {
  /** Custom CSS Classes */
  className: PropTypes.string,
  /** Contents in Block */
  children: PropTypes.any,
}

const Block = ({children, className, ...other}) => {
  const classes = classNames(
    'component-block', /* component name */
    styles.block, /* localized styles */
    className /* user specified classNames */
    // propBasedClasses /* prop based classnames */
  )

  return (
    <span {...other} className={classes}>
      {children}
    </span>
  )
}

Block.propTypes = propTypes

export default Block



// WEBPACK FOOTER //
// ../src/components/Block/Block.js